import styles from "./index.module.css";
import { Link } from "react-router-dom";

import { Button } from "@primer/react";
import useMediaQuery from "../../customHooks";
import Redirect from "../Images/redirect";

const Navbar = () => {
  const isMobile = useMediaQuery("(max-width: 1020px)");

  return (
    <header className={styles.nav}>
      <div className={styles.navContainer}>
        <Link to="https://changelog.testmuai.com">
          <div className={styles.navTitleContainer}>
            <img
              src="../../testmu-logo.svg"
              alt="TestMu AI Logo"
              height="26"
              width="auto"
            />
            <h1 className={styles.navTitle}>TestMu AI Announcements</h1>
          </div>
        </Link>
        <Button
          variant="primary"
          size="small"
          style={{
            fontWeight: 600,
          }}
          onClick={() => {
            window.open("https://www.testmuai.com");
          }}
          trailingVisual={Redirect}
        >
          Go to Website
        </Button>
      </div>
    </header>
  );
};

export default Navbar;
